// This file was auto-generated by NTypewriter for DA.Types.Shared.Export.DTOs.SerializationConstants
export const serializationConstants = {
	combinedStatsKey:"CombinedStatsKey",
};
